import { UrlParamKeyValuePair } from '../../../common';
import { getFetchSFCCPricesUrlGetBySkus, getPricingHeaders } from '../../utilities';
import { getPricingApiConfig, pricingHttp } from '../pricing-api';

export const getPricesBySkus = async <T>(
  productSkus: string[],
  queryParams?: UrlParamKeyValuePair[]
): Promise<T | null> => {
  const { shopApiClientId } = getPricingApiConfig();
  const url: string = getFetchSFCCPricesUrlGetBySkus(productSkus, queryParams);
  const requestConfig = await getPricingHeaders(shopApiClientId);

  const response = await pricingHttp.get<T>(url, requestConfig);
  return response?.data;
};
